(function () {

    var module = angular.module('uwAgenda.programinfo');
    module.controller('ProgramInfoCreateController', ['$uibModalInstance', '$q', 'languages', 'ProgramInfo', 'ItemTableService', 'ProgramInfoService', ProgramInfoCreateControllerFn]);

    // create info screen notification modal controller
    function ProgramInfoCreateControllerFn($uibModalInstance, $q, languages, ProgramInfo, ItemTableService, ProgramInfoService) {

        /* jshint validthis:true */
        var vm = this;

        vm.languages = [];
        vm.currentUser = null;
        vm.info = { translations: [] };
        vm.abort = abort;
        vm.save = save;
        vm.programInfo = {};

        activate();


        // activate controller
        function activate() {
            vm.programInfo = new ProgramInfo();
            vm.table = ItemTableService.data;
            vm.languages = languages;

        }

        // abort, dismiss modal
        function abort() {
            $uibModalInstance.dismiss('cancel');
        }


        // save notification
        function save() {

            var i = 0;
            var length = vm.info.translations.length;
            var promises = [];

            if (0 === length) {
                // notify user that he has not submitted any content
                return;
            }

            // run through each translation notification and post to api
            for (i; i < length; i++) {

                var currentTranslation = vm.info.translations[i];
                var currentTranslationClean = {
                    title: currentTranslation.programInfoTitle,
                    subTitle: currentTranslation.programInfoSubTitle,
                    content: currentTranslation.programInfoContent,
                    hyperLink: currentTranslation.programInfoHyperLink,
                    fK_Language: currentTranslation.language.id
                };

                if (typeof currentTranslation !== "undefined") {
                    promises.push(ProgramInfoService.saveNotification(currentTranslationClean));
                }
            }

            // wait for all promises
            $q.all(promises).then(function () {
                $uibModalInstance.close();
            });
        }


    }

})();